import apiClient from "./client";

export const getAdminBoards = async () => {
  const response = await apiClient.get("/boards/admin");
  return response.data;
};

/** Full board admin row (`pdfDocuments`, etc.). List may omit PDF fields. */
export const getAdminBoardById = async (id) => {
  const response = await apiClient.get(`/boards/admin/${id}`);
  return response.data;
};

export const createAdminBoard = async (payload) => {
  const response = await apiClient.post("/boards/admin", payload);
  return response.data;
};

/**
 * Create/update every language variant of a board in a single atomic call.
 * `payload.languages` is a list of per-language content objects sharing one boardType.
 * Returns the list of admin board rows (one per language) for that board type.
 */
export const saveAdminBoardAllLanguages = async (payload) => {
  const response = await apiClient.post("/boards/admin/save", payload);
  return response.data;
};

export const updateAdminBoard = async ({ id, payload }) => {
  const response = await apiClient.put(`/boards/admin/${id}`, payload);
  return response.data;
};

export const deleteAdminBoard = async ({ id }) => {
  await apiClient.delete(`/boards/admin/${id}`);
};

export const uploadAdminBoardImage = async ({ id, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/boards/admin/${id}/image`, formData, {
    headers: { "Content-Type": false },
  });
  return response.data;
};

export const removeAdminBoardImage = async ({ id }) => {
  const response = await apiClient.delete(`/boards/admin/${id}/image`);
  return response.data;
};

const assertPdfFile = (file) => {
  if (!file) {
    throw new Error("Please select a PDF file.");
  }
  const byMime = String(file.type || "").toLowerCase() === "application/pdf";
  const byName = /\.pdf$/i.test(String(file.name || ""));
  if (!byMime && !byName) {
    throw new Error("Only PDF files are allowed.");
  }
};

export const createAdminBoardPdf = async ({ id, title, productSlug }) => {
  const body = { title: String(title || "").trim() };
  const slug = String(productSlug ?? "").trim();
  if (slug) body.productSlug = slug;
  const response = await apiClient.post(`/boards/admin/${id}/pdfs`, body);
  return response.data;
};

export const updateAdminBoardPdf = async ({ id, pdfId, payload }) => {
  const response = await apiClient.put(`/boards/admin/${id}/pdfs/${pdfId}`, payload);
  return response.data;
};

export const uploadAdminBoardPdfFile = async ({ id, pdfId, file }) => {
  assertPdfFile(file);
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/boards/admin/${id}/pdfs/${pdfId}/file`, formData, {
    headers: { "Content-Type": false },
  });
  return response.data;
};

export const deleteAdminBoardPdf = async ({ id, pdfId }) => {
  const response = await apiClient.delete(`/boards/admin/${id}/pdfs/${pdfId}`);
  return response.data;
};

export const clearAdminBoardPdfFile = async ({ id, pdfId }) => {
  const response = await apiClient.delete(`/boards/admin/${id}/pdfs/${pdfId}/file`);
  return response.data;
};
